import React, { useEffect, useState } from "react";
import Header from "../components/Navbar/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Navbar/Footer";
import axios from "axios";
import { getLocalStorageData } from "../utils/helpers/helpers";
import { API_URL } from "../components/network/Api";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { post } from "../utils/helpers/http";
import Loader from "../Loader/Loader";
const Price = () => {
  const [prices, setPrices] = useState([]);
  const [title, setTitle] = useState("");
  const [lastEditedIndex, setLastEditedIndex] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteItemId, setDeleteItemId] = useState(null);
  const [disableAddButton, setDisableAddButton] = useState(false);
  const [disableUpdateButton, setDisableUpdateButton] = useState(false);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    fetchPrices();
  }, []);

  const fetchPrices = async () => {
    setLoader(true);
    try {
      const accessToken = getLocalStorageData("accessToken");
      const authorizationToken = getLocalStorageData("authorizationToken");
      const response = await axios.get(
        `${API_URL}/ManagePrice/GetPrices`,
        {
          headers: {
            UtcOffsetInSecond: 19800,
            AppVersion: 1,
            AccessToken: accessToken,
            Authorization: `Bearer ${authorizationToken}`,
          },
        }
      );
      if (Array.isArray(response.data.data)) {
        setPrices(response.data.data);
      } else {
      }
    } catch (error) {
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };
  const handlePriceChange = (index, value) => {
    const newPrices = [...prices];
    const isPercentageField = newPrices[index].serviceTitle === "Card Processing Fee (In %)";
    
    if (value === "") {
      newPrices[index].servicePrice = null;
      setPrices(newPrices);
      setLastEditedIndex(index);
      return;
    }
    
    if (isPercentageField) {
      // Allow decimal values between 0.01 and 100 for percentage field
      const decimalRegex = /^\d*\.?\d{0,2}$/;
      const numValue = parseFloat(value);
      
      if (decimalRegex.test(value) && (numValue >= 0.01 && numValue <= 100 || value === "0")) {
        newPrices[index].servicePrice = value;
        setPrices(newPrices);
        setLastEditedIndex(index);
      }
    } else {
      // For non-percentage fields, only allow whole numbers
      const numValue = parseInt(value);
      if (!isNaN(numValue)) {
        if (numValue >= 1 && numValue < 100000) {
          newPrices[index].servicePrice = numValue;
          setPrices(newPrices);
          setLastEditedIndex(index);
        } else if (value === "0") {
          // Allow 0 but don't allow negative numbers
          newPrices[index].servicePrice = 0;
          setPrices(newPrices);
          setLastEditedIndex(index);
        }
      }
    }
  };
  const toTitleCase = (str) => {
    return str.replace(/\w\S*/g, function (txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
  };
  // const handleAddItem = async () => {
  //   if (title.trim() === "") {
  //     toast.error("Empty field is not allowed");
  //     return;
  //   }
  //   try {
  //     let body = {
  //       serviceTitle: toTitleCase(title),
  //       prices: 0,
  //       createdBy: 0,
  //       updatedBy: 0,
  //     };
  //     const response = await post('/ManagePrice/AddUpdatePrices', body);
  //     fetchPrices(response.data.data);
  //     toast.success("Item added successfully");
  //   } catch (error) {
  //   }
  // };
  // const handleDeleteService = async (id) => {
  //   setShowDeleteModal(true);
  //   setDeleteItemId(id);
  // };

  // const handleDeleteConfirmation = async () => {
  //   try {
  //     let body = { id: deleteItemId }
  //     const response = await post('/ManagePrice/DeleteServices', body)
  //     fetchPrices(response.data.data);
  //     toast.success("Item deleted successfully")
  //   } catch (error) {
  //   } finally {
  //     setShowDeleteModal(false);
  //   }
  // };
  const handleUpdatePrices = async () => {
    try {
      const servicePriceTableTypeList = prices.map(price => ({
        id: price.id,
        servicePrice: price.servicePrice
      }));


      if (servicePriceTableTypeList.some((price) => price.servicePrice === "" || price.servicePrice === null)) {
        toast.error("Price(s) can't be empty ");
        return;
      }
let body =  { servicePriceTableTypeList }
      const response = await post('/ManagePrice/UpdateAllPrices', body)
      console.log(response)
      toast.success("Price updated successfully")
    } catch (error) {
    }
  };


  const handleClear = async () => {
    try {
      const accessToken = getLocalStorageData("accessToken");
      const authorizationToken = getLocalStorageData("authorizationToken");
      const response = await axios.get(
        `${API_URL}/ManagePrice/GetPrices`,
        {
          headers: {
            UtcOffsetInSecond: 19800,
            AppVersion: 1,
            AccessToken: accessToken,
            Authorization: `Bearer ${authorizationToken}`,
          },
        }
      );
      if (Array.isArray(response.data.data)) {
        setPrices(response.data.data);
      } else {
        setPrices([]);
      }
    } catch (error) {
      setPrices([]);
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace') {
      e.preventDefault(); // Prevent the default behavior of the backspace key
      const newPrices = [...prices];
      let newValue = newPrices[index].servicePrice !== null ? newPrices[index].servicePrice.toString() : "";
      newValue = newValue.slice(0, -1); // Remove the last digit
      newPrices[index].servicePrice = newValue === "" ? null : parseFloat(newValue);
      setPrices(newPrices);
      setLastEditedIndex(index);
    }
  };
  
  const handleKeyPress = (index, e) => {
    const isPercentageField = prices[index].serviceTitle === "Card Processing Fee (In %)";
    const allowedKeys = [8, 9, 13, 16, 17, 18, 19, 20, 27, 46, 37, 38, 39, 40]; // control keys
    
    if (isPercentageField) {
      // Allow numbers, decimal point for percentage field
      const keyCode = e.which || e.keyCode;
      if (
        !(keyCode >= 48 && keyCode <= 57) && // numbers
        keyCode !== 190 && // decimal point
        !allowedKeys.includes(keyCode) // control keys
      ) {
        e.preventDefault();
      }
    } else {
      // Only allow numbers for non-percentage fields
      const keyCode = e.which || e.keyCode;
      if (
        !(keyCode >= 48 && keyCode <= 57) && // numbers
        !allowedKeys.includes(keyCode) // control keys
      ) {
        e.preventDefault();
      }
    }
  };



  return (
    <>
      <Header />
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
              <div className="page-header">
                <div className="lefth d-flex align-items-center justify-content-between flex-wrap">
                  <h1 className="page-title me-3">Manage Prices</h1>
                  {/* <div className="addtop d-flex align-items-center">
                    <input
                      type="text"
                      className="form-control me-3"
                      placeholder="Enter title"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      min={1}
                      max={99999}
                    />
                    <button className="btn btn-primary"
                     onClick={handleAddItem}
                     disabled={disableAddButton}
                     >
                      Add Item
                    </button>
                  </div> */}
                </div>
              </div>
              <div className="page-content">
                <div className="row">
                  {prices.map((price, index) => (
                    <div className="col-lg-3 col-md-6" key={price.id}>
                      <div className="lbag mb-3">
                        {/* {!price.isFixedFee && (
                          <div className="closethisbag" onClick={() => handleDeleteService(price.id)}></div>
                        )} */}
                    
                        <div className="form-group mb-0">
                          <label className="form-label">{price.serviceTitle}</label>
                          <div className="dollarsign">
              {price.serviceTitle !== "Card Processing Fee (In %)" && <span>$</span>}
              <input
                type="text"
                className="form-control"
                value={price.servicePrice || ""}
                onChange={(e) => handlePriceChange(index, e.target.value)}
                onKeyDown={(e) => handleKeyDown(index, e)}
                onKeyPress={(e) => handleKeyPress(index, e)}
                inputMode={price.serviceTitle === "Card Processing Fee (In %)" ? "decimal" : "numeric"}
                pattern={price.serviceTitle === "Card Processing Fee (In %)" ? "[0-9]*\.?[0-9]*" : "[0-9]*"}
                placeholder={price.serviceTitle === "Card Processing Fee (In %)" ? "0.00" : "0"}
              />
            </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-4">
                {/* <button className="btn btn-default" onClick={handleClear}>
                    Clear
                  </button> */}

<button className="btn btn-default" onClick={handleClear}>
  Clear
</button>
                  <button className="btn btn-primary"
                   onClick={handleUpdatePrices}
                   disabled={disableUpdateButton}

                   >Update</button>
                </div>
              </div>
            </div>
            <ToastContainer
             position="top-right"
             autoClose={5000}
             hideProgressBar={false}
             closeOnClick
             pauseOnHover
             draggable
             onOpen={() => {
               setDisableAddButton(true);
               setDisableUpdateButton(true);
               setTimeout(() => {
                 setDisableAddButton(false);
                 setDisableUpdateButton(false);
               }, 5000);
             }}
             onClose={() => { }}
            />
          </div>
          {loader && <Loader/>}
          <Footer />
        </div>
      </div>
      {/* {showDeleteModal && (
        <div className="modal" tabIndex="-1" role="dialog" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete Item Confirmation</h5>
                <button type="button" className="btn-close" onClick={() => setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this item?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleDeleteConfirmation}>Yes</button>
              </div>
            </div>
          </div>
        </div>
      )} */}
    </>
  );
};
export default Price;